import axios from 'axios';
import QueryString from 'query-string';

import { ApiUrl } from '@api/ApiUtils';
import type { BidRequestWithLotIds } from '@api/events/loadEvent';
import type { ListedLot } from '@features/buyer-line-items-pagination/types/listed-lot';
import type { LotPage, LotPageRequest } from '@features/buyer-line-items-pagination/types/lot-page';
import type { ID } from 'types';

const ALL_LOTS_PAGE_SIZE = 10000;

const EVENT_LOTS_PARAMS = {
  expand: ['incumbent_id', 'line_item_questions_count', 'has_tier_line_items'],
  ignore_filter_fields: true,
  items: ALL_LOTS_PAGE_SIZE,
};

/** The event's lot list in one request, with headers and row counts but no rows. */
export const getEventLots = async (eventId: ID): Promise<ListedLot[]> => {
  const stringParams = QueryString.stringify(EVENT_LOTS_PARAMS, { arrayFormat: 'bracket' });
  const { data } = await axios.get<{ records: ListedLot[] }>(ApiUrl(`/events/${eventId}/lots?${stringParams}`));

  return data.records;
};

/** The event without its lots, as `loadEvent` reads it. */
export const getEvent = async (eventId: ID): Promise<BidRequestWithLotIds> => {
  const { data } = await axios.get<{ bid_request: BidRequestWithLotIds }>(ApiUrl(`/events/${eventId}`));

  return data.bid_request;
};

/** One page of a lot's rows, sent as `offset`/`limit` (row groups for a tiered lot). */
export const getLotPage = async ({ eventId, lotId, page, pageSize, search }: LotPageRequest): Promise<LotPage> => {
  const params = {
    limit: pageSize,
    offset: (page - 1) * pageSize,
    ...(search ? { search } : {}),
  };
  const { data } = await axios.get<LotPage>(ApiUrl(`/events/${eventId}/lots/${lotId}/buyer_line_items`), { params });

  return data;
};
